(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-kategoritekst"]) return;
  try {
    
(function(){
  function init(main){
    if(main.dataset.esReady) return; main.dataset.esReady='1';
    var body=main.querySelector('.es-ct__body'); if(!body) return;
    body.querySelectorAll('p').forEach(function(p){ if(!p.textContent.replace(/ /g,'').trim() && !p.querySelector('img,a,iframe')) p.remove(); });
    var heads=[].slice.call(body.querySelectorAll('h2,h3'));
    var faqHead=heads.filter(function(h){return /ofte stillede/i.test(h.textContent);})[0];
    if(faqHead && faqHead.parentNode===body){
      var wrap=document.createElement('div'); wrap.className='es-ct__faq';
      var h2=document.createElement('h2'); h2.textContent=faqHead.textContent.trim();
      body.insertBefore(h2,faqHead); body.insertBefore(wrap,faqHead);
      var n=faqHead.nextElementSibling; faqHead.remove();
      while(n && n.tagName!=='H2'){
        if(n.tagName==='H3'){
          var d=document.createElement('details'), s=document.createElement('summary'), a=document.createElement('div');
          s.textContent=n.textContent.trim(); a.className='es-ct__a'; d.appendChild(s); d.appendChild(a); wrap.appendChild(d);
          var m=n.nextElementSibling;
          while(m && m.tagName!=='H3' && m.tagName!=='H2' && m.tagName!=='SCRIPT'){ var mn=m.nextElementSibling; a.appendChild(m); m=mn; }
          n.remove(); n=m; continue;
        }
        n=n.nextElementSibling;
      }
      if(!wrap.children.length){ wrap.remove(); }
    }
    var group=null;
    [].slice.call(body.children).forEach(function(el){
      var next=el.nextElementSibling;
      if(el.tagName==='H3' && next && next.tagName==='UL'){
        if(!group || group.nextElementSibling!==el){ group=document.createElement('div'); group.className='es-ct__cards'; body.insertBefore(group,el); }
        var c=document.createElement('div'); c.className='es-ct__card'; c.appendChild(el); c.appendChild(next); group.appendChild(c);
      }
    });
  }
  function run(){ document.querySelectorAll('[data-es-ct]').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();
})();
